(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["swag"] = factory();
	else
		root["swag"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "dd63");
/******/ })
/************************************************************************/
/******/ ({

/***/ "405b":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "dd63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "TangoCardColors", function() { return /* reexport */ TangoCardColors; });
__webpack_require__.d(__webpack_exports__, "TangoCardStorybookStore", function() { return /* reexport */ TangoCardStorybookStore; });
__webpack_require__.d(__webpack_exports__, "TcThemeLight", function() { return /* reexport */ TcThemeLight; });

// CONCATENATED MODULE: /builds/engineering/mango/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("405b")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./src/TangoCardColorVariables.js
const TangoCardColors = {
  primary_50: '#E0F5FA',
  primary_100: '#B2E7F1',
  primary_200: '#82D7E8',
  primary_300: '#54C7DD',
  primary_400: '#39BCD4',
  primary_500: '#2DB0CC',
  primary_600: '#29A1B9',
  primary_700: '#248D9F',
  primary_800: '#207987',
  primary_900: '#19565D',
  secondary_50: '#ECEDEE',
  secondary_100: '#CED4D8',
  secondary_200: '#AEB7BF',
  secondary_300: '#8D9AA6',
  secondary_400: '#758593',
  secondary_500: '#5D7182',
  secondary_600: '#516371',
  secondary_700: '#42505B',
  secondary_800: '#333D46',
  secondary_900: '#22292F',
  chrome_50: '#EDEFF0',
  chrome_100: '#D0D8DB',
  chrome_200: '#B1BFC4',
  chrome_300: '#91A5AD',
  chrome_400: '#78919A',
  chrome_500: '#607E89',
  chrome_600: '#556F78',
  chrome_700: '#465B63',
  chrome_800: '#38484E',
  chrome_900: '#273337',
  shadow_small: 'box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15)',
  shadow_regular: 'box-shadow: 0 8px 16px 0 rgba(0,0,0,0.15)',
  shadow_large: 'box-shadow: 0 16px 48px 0 rgba(0,0,0,0.15)',
  status_50: '#F3F8E8',
  status_100: '#E1EDC5',
  status_200: '#CCE29F',
  status_300: '#B8D678',
  status_400: '#A7CE59',
  status_500: '#97C539',
  status_600: '#87B531',
  status_700: '#72A127',
  status_800: '#5E8D1E',
  status_900: '#396C09',
  orange_50: '#FFF2E1',
  orange_100: '#FFDEB4',
  orange_200: '#FFC985',
  orange_300: '#FFB256',
  orange_400: '#FFA137',
  orange_500: '#FF9224',
  orange_600: '#FF8623',
  orange_700: '#F87622',
  orange_800: '#F16521',
  orange_900: '#E64C1F',
  red_50: '#FFEAED',
  red_100: '#FFCACF',
  red_200: '#F59594',
  red_300: '#EC6B6A',
  red_400: '#F64644',
  red_500: '#FB3025',
  red_600: '#EC2227',
  red_700: '#DA1220',
  red_800: '#CD0118',
  red_900: '#BF0007',
  yellow_50: '#FFFDE5',
  yellow_100: '#FFF8BF',
  yellow_200: '#FFF394',
  yellow_300: '#FFEE68',
  yellow_400: '#FEE942',
  yellow_500: '#FFE712',
  yellow_600: '#FED40A',
  yellow_700: '#FDBB00',
  yellow_800: '#FCA200',
  yellow_900: '#FB7600',
  gray_50: '#FFFFFF',
  gray_100: '#FAFAFA',
  gray_200: '#F5F5F5',
  gray_300: '#F0F0F0',
  gray_400: '#DEDEDE',
  gray_500: '#C2C2C2',
  gray_600: '#979797',
  gray_700: '#818181',
  gray_800: '#606060',
  gray_900: '#606060',
  black_50: '#F5F5F5',
  black_100: '#E9E9E9',
  black_200: '#D9D9D9',
  black_300: '#C4C4C4',
  black_400: '#9D9D9D',
  black_500: '#7B7B7B',
  black_600: '#555555',
  black_700: '#434343',
  black_800: '#262626',
  black_900: '#000000',
  primarytext_900: '#22292F',
  secondarytext_500: '#5D7182',
  basebackground_50: '#EDEFF0',
  alt_lightblue: '#8192a1',
  alt_darkblue: '#4b6174',
  alt_lightgreen: '#B9D094',
  alt_darkgreen: '#5C8D23',
  alt_lightorange: '#DCCA53',
  alt_darkoragne: '#DF7500',
  alt_lightbrown: '#973C13',
  alt_darkbrown: '#4B3827',
  alt_pewter: '#5B5A5B',
  alt_tan: '#A39B88'
}

// CONCATENATED MODULE: ./src/TangoCardColors.js
const TangoCardStorybookStore = {
  primaryColors: [
    {
      color: '#E0F5FA',
      colorName: '50',
      id: 1
    },
    {
      color: '#B2E7F1',
      colorName: '100',
      id: 2
    },
    {
      color: '#82D7E8',
      colorName: '200',
      id: 3
    },
    {
      color: '#54C7DD',
      colorName: '300',
      id: 4
    },
    {
      color: '#39BCD4',
      colorName: '400',
      id: 5
    },
    {
      color: '#2DB0CC',
      colorName: '500',
      id: 6
    },
    {
      color: '#29A1B9',
      colorName: 'Blue 600',
      class: 'base-color',
      id: 7
    },
    {
      color: '#248D9F',
      colorName: '700',
      class: 'inverted',
      id: 8
    },
    {
      color: '#207987',
      colorName: '800',
      class: 'inverted',
      id: 9
    },
    {
      color: '#19565D',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  secondaryColors: [
    {
      color: '#ECEDEE',
      colorName: '50',
      id: 1
    },
    {
      color: '#CED4D8',
      colorName: '100',
      id: 2
    },
    {
      color: '#AEB7BF',
      colorName: '200',
      id: 3
    },
    {
      color: '#8D9AA6',
      colorName: '300',
      id: 4
    },
    {
      color: '#758593',
      colorName: '400',
      id: 5
    },
    {
      color: '#5D7182',
      colorName: '500',
      class: 'inverted',
      id: 6
    },
    {
      color: '#516371',
      colorName: '600',
      class: 'inverted',
      id: 7
    },
    {
      color: '#42505B',
      colorName: '700',
      class: 'inverted',
      id: 8
    },
    {
      color: '#333D46',
      colorName: 'Gray Blue 800',
      class: 'base-color inverted',
      id: 9
    },
    {
      color: '#22292F',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  chromeColors: [
    {
      color: '#EDEFF0',
      colorName: 'Chrome 50',
      class: 'base-color',
      id: 1
    },
    {
      color: '#D0D8DB',
      colorName: '100',
      id: 2
    },
    {
      color: '#B1BFC4',
      colorName: '200',
      id: 3
    },
    {
      color: '#91A5AD',
      colorName: '300',
      id: 4
    },
    {
      color: '#78919A',
      colorName: '400',
      id: 5
    },
    {
      color: '#607E89',
      colorName: '500',
      class: 'inverted',
      id: 6
    },
    {
      color: '#556F78',
      colorName: '600',
      class: 'inverted',
      id: 7
    },
    {
      color: '#465B63',
      colorName: '700',
      class: 'inverted',
      id: 8
    },
    {
      color: '#38484E',
      colorName: '800',
      class: 'inverted',
      id: 9
    },
    {
      color: '#273337',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  statusColors: [
    {
      color: '#F3F8E8',
      colorName: '50',
      id: 1
    },
    {
      color: '#E1EDC5',
      colorName: '100',
      id: 2
    },
    {
      color: '#CCE29F',
      colorName: '200',
      id: 3
    },
    {
      color: '#B8D678',
      colorName: '300',
      id: 4
    },
    {
      color: '#A7CE59',
      colorName: '400',
      id: 5
    },
    {
      color: '#97C539',
      colorName: '500',
      id: 6
    },
    {
      color: '#87B531',
      colorName: '600',
      id: 7
    },
    {
      color: '#72A127',
      colorName: 'Green 700',
      class: 'base-color',
      id: 8
    },
    {
      color: '#5E8D1E',
      colorName: '800',
      id: 9
    },
    {
      color: '#396C09',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  orangeColors: [
    {
      color: '#FFF2E1',
      colorName: '50',
      id: 1
    },
    {
      color: '#FFDEB4',
      colorName: '100',
      id: 2
    },
    {
      color: '#FFC985',
      colorName: '200',
      id: 3
    },
    {
      color: '#FFB256',
      colorName: '300',
      id: 4
    },
    {
      color: '#FFA137',
      colorName: '400',
      id: 5
    },
    {
      color: '#FF9224',
      colorName: '500',
      id: 6
    },
    {
      color: '#FF8623',
      colorName: '600',
      id: 7
    },
    {
      color: '#F87622',
      colorName: '700',
      id: 8
    },
    {
      color: '#F16521',
      colorName: 'Orange 800',
      class: 'base-color',
      id: 9
    },
    {
      color: '#E64C1F',
      colorName: '900',
      id: 10
    }
  ],
  redColors: [
    {
      color: '#FFEAED',
      colorName: '50',
      id: 1
    },
    {
      color: '#FFCACF',
      colorName: '100',
      id: 2
    },
    {
      color: '#F59594',
      colorName: '200',
      id: 3
    },
    {
      color: '#EC6B6A',
      colorName: '300',
      id: 4
    },
    {
      color: '#F64644',
      colorName: '400',
      id: 5
    },
    {
      color: '#FB3025',
      colorName: '500',
      id: 6
    },
    {
      color: '#EC2227',
      colorName: 'Red 600',
      class: 'base-color',
      id: 7
    },
    {
      color: '#DA1220',
      colorName: '700',
      class: 'inverted',
      id: 8
    },
    {
      color: '#CD0118',
      colorName: '800',
      class: 'inverted',
      id: 9
    },
    {
      color: '#BF0007',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  yellowColors: [
    {
      color: '#FFFDE5',
      colorName: '50',
      id: 1
    },
    {
      color: '#FFF8BF',
      colorName: '100',
      id: 2
    },
    {
      color: '#FFF394',
      colorName: '200',
      id: 3
    },
    {
      color: '#FFEE68',
      colorName: '300',
      id: 4
    },
    {
      color: '#FEE942',
      colorName: '400',
      id: 5
    },
    {
      color: '#FFE712',
      colorName: 'Yellow 500',
      class: 'base-color',
      id: 6
    },
    {
      color: '#FED40A',
      colorName: '600',
      id: 7
    },
    {
      color: '#FDBB00',
      colorName: '700',
      id: 8
    },
    {
      color: '#FCA200',
      colorName: '800',
      id: 9
    },
    {
      color: '#FB7600',
      colorName: '900',
      id: 10
    }
  ],
  basicColors: [
    {
      color: '#FFFFFF',
      colorName: '50',
      class: 'base-color',
      id: 1
    },
    {
      color: '#FAFAFA',
      colorName: '100',
      id: 2
    },
    {
      color: '#F5F5F5',
      colorName: '200',
      id: 3
    },
    {
      color: '#F0F0F0',
      colorName: '300',
      id: 4
    },
    {
      color: '#DEDEDE',
      colorName: '400',
      id: 5
    },
    {
      color: '#C2C2C2',
      colorName: '500',
      id: 6
    },
    {
      color: '#979797',
      colorName: '600',
      id: 7
    },
    {
      color: '#818181',
      colorName: '700',
      id: 8
    },
    {
      color: '#606060',
      colorName: '800',
      class: 'inverted',
      id: 9
    },
    {
      color: '#3C3C3C',
      colorName: '900',
      class: 'inverted',
      id: 10
    }
  ],
  naColors: [
    {
      color: '#F5F5F5',
      colorName: '50',
      id: 1
    },
    {
      color: '#E9E9E9',
      colorName: '100',
      id: 2
    },
    {
      color: '#D9D9D9',
      colorName: '200',
      id: 3
    },
    {
      color: '#C4C4C4',
      colorName: '300',
      id: 4
    },
    {
      color: '#9D9D9D',
      colorName: '400',
      id: 5
    },
    {
      color: '#7B7B7B',
      colorName: '500',
      id: 6
    },
    {
      color: '#555555',
      colorName: '600',
      class: 'inverted',
      id: 7
    },
    {
      color: '#434343',
      colorName: '700',
      class: 'inverted',
      id: 8
    },
    {
      color: '#262626',
      colorName: '800',
      class: 'inverted',
      id: 9
    },
    {
      color: '#000000',
      colorName: 'Black 900',
      class: 'base-color inverted',
      id: 10
    }
  ],
  altCol1: [{
    color: '#8192a1',
    colorName: 'dark',
    class: 'rectangle',
    id: 1
  },
  {
    color: '#4b6174',
    colorName: 'light',
    class: 'inverted rectangle',
    id: 2
  }],
  altCol2: [{
    color: '#B9D094',
    colorName: 'dark',
    class: 'rectangle',
    id: 3
  },
  {
    color: '#5C8D23',
    colorName: 'dark',
    class: 'rectangle',
    id: 4
  }],
  altCol3: [{
    color: '#DCCA53',
    colorName: 'dark',
    class: 'rectangle',
    id: 5
  },
  {
    color: '#DF7500',
    colorName: 'dark',
    class: 'rectangle',
    id: 6
  }],
  altCol4: [{
    color: '#973C13',
    colorName: 'light',
    class: 'inverted rectangle',
    id: 7
  },
  {
    color: '#4B3827',
    colorName: 'light',
    class: 'inverted rectangle',
    id: 8
  }],
  altCol5: [{
    color: '#5B5A5B',
    colorName: 'light',
    class: 'inverted rectangle',
    id: 9
  },
  {
    color: '#A39B88',
    colorName: 'dark',
    class: 'rectangle',
    id: 10
  }]
}

// CONCATENATED MODULE: ./src/TangoCardVuetifyTheme.js


const TcThemeLight = {
  primary: TangoCardColors.primary_600,
  secondary: TangoCardColors.secondary_800,
  accent: TangoCardColors.orange_800,
  error: TangoCardColors.red_600,
  info: TangoCardColors.alt_lightblue,
  success: TangoCardColors.alt_darkgreen,
  warning: TangoCardColors.alt_darkoragne
}

// CONCATENATED MODULE: ./index.js




// CONCATENATED MODULE: /builds/engineering/mango/node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
});
//# sourceMappingURL=swag.umd.js.map